import React                from 'react';
import { useSelector }      from 'react-redux';

import AccusedsList         from './treatment/AccusedsList';
import ActionsList          from './treatment/ActionsList';
import ActuationActions     from './treatment/ActuationActions';
import ActuationsList       from './treatment/ActuationsList';
import AudienceResults      from './treatment/AudienceResults';
import IntermediatesList    from './treatment/IntermediatesList';

import { AGENDADA }         from '../../../data/audienceStates';


const AudienceTreatment = () => {

    // Accedo al store
    const audience = useSelector(state => state.audiences.audienceWork);
    
    // Renderizo
    return (
        <div className="row">
            {   audience &&
                    <React.Fragment>
                        <ActuationsList
                            audience = { audience }
                        />

                        <ActuationActions
                            audience = { audience }
                        />

                        <IntermediatesList
                            audience = { audience }
                        />
                        
                        <AccusedsList
                            audience = { audience }
                        />

                        {   audience.estado.id > AGENDADA &&
                                <AudienceResults
                                    audience = { audience }
                                />
                        }

                        {   audience.estado.id >= AGENDADA &&
                                <ActionsList
                                    audience = { audience }
                                />
                        }   

                </React.Fragment>
            }
        </div>
    );
};

export default AudienceTreatment;